const schema = (shops, booth) => ({
  type: 'object',
  required: [],
  properties: {
    shop_id: {
      type: 'string',
      title: 'فروشگاه',
      // enum: shops.map((o) => o.id),
      // enumNames: shops.map((o) => o.title),
      // uniqueItems: true,
      // default: shops[0]?.id,
    },
    base_store_code: {
      type: 'string',
      title: 'انبار مرکزی',
      // enum: booth.map((o) => o.code),
      // enumNames: booth.map((o) => o.title),
      // uniqueItems: true,
      // default: booth[0]?.code,
    },
    update_type: {
      type: 'boolean',
      title: 'غیرفعال کردن محصولات قبلی',
      default: false,
      // enum: ["FULL", "SINGLE"],
      // enumNames: ["غیر فعال کردن محصولات قبلی", "بروزرسانی تک موردی"],
      // uniqueItems: true
    },
    booth_stock_status: {
      type: 'boolean',
      title: 'موجودی غرفه ها واقعی است',
      default: true,
      // enum: ["REAL", "UNREAL"],
      // enumNames: ["واقعی", "غیر واقعی"],
      // uniqueItems: true
    },
  },
});

export default schema;